import AbstractComponent from "./abstract-component";

const createTemplate = ({title, link, imgSrc, date, content}) => {
  return (
    `<aside class="news__card">
      <a class="news__link" href="${link}">
        <h3 class="news__title" >${title}</h3>
        <time class="news__date">${date}</time>
        <p class="news__text">${content}</p>

        <div class="news__buttonWrap">
          <button class="news__moreButton" type="button">Узнать больше</button>

          <svg class="news__moreIcon" aria-hidden="true" width="18" height="18">
            <use class="" href="sienge/img/sprite.svg#arrow"></use>
          </svg>
        </div>
      </a>
    </aside>`
  );
};

// data-swiper-parallax-opacity="0.5" data-swiper-parallax="150"

// {/* <img class="news__image" src="${imgSrc}" alt="${title}"> */}


// {/* <p class="news__text">${content}</p> */}


export default class NewsCardComponent extends AbstractComponent {
  constructor({data = ``}) {
    super();

    this._data = data;
  }

  getTemplate() {
    return createTemplate(this._data);
  }
}
